import React from "react";
import DataTable, { TableProps } from "react-data-table-component";
import { useTheme } from "@mui/material/styles";
import { Skeleton, Stack, Typography } from "@mui/material";

interface ITableClient {
  title?: string;
}

function TableClient({
  data,
  columns,
  title,
  customStyles,
  conditionalRowStyles,
  ...tableProps
}: ITableClient & TableProps<any>) {
  const theme = useTheme();

  return (
    <DataTable
      data={data}
      columns={columns}
      noDataComponent={
        <Typography
          sx={{ fontSize: "14px", textAlign: "center", padding: "20px 0" }}
        >
          {title ? `Không có ${title}` : "Không có dữ liệu"}
        </Typography>
      }
      progressComponent={
        <Stack
          gap={2}
          sx={{
            width: "100%",
            py: 1,
            px: 2,
          }}
        >
          {new Array(5).fill(0).map((_, index) => {
            return (
              <Stack key={index} direction="row" alignItems="center" gap={1}>
                <Skeleton
                  variant="rectangular"
                  sx={{ width: "20px", height: "20px" }}
                />
                <Skeleton
                  variant="rounded"
                  sx={{ width: "100px", height: "15px" }}
                />
                <Stack sx={{ width: "400px" }}>
                  <Skeleton
                    variant="text"
                    sx={{ width: "40%", height: "15px" }}
                  />
                  <Skeleton
                    variant="text"
                    sx={{ width: "100%", height: "15px" }}
                  />
                </Stack>
                <Skeleton
                  variant="rounded"
                  sx={{ width: "40px", height: "15px" }}
                />
              </Stack>
            );
          })}
        </Stack>
      }
      customStyles={{
        headRow: {
          style: {
            minHeight: "40px",
            fontWeight: 600,
            backgroundColor: theme.palette.background.paper,
            overflow: "hidden",
          },
        },
        headCells: {
          style: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            padding: "8px 16px",
            fontSize: "14px",
            "& input": {
              accentColor: theme.palette.primary.main,
            },
          },
        },
        rows: {
          style: {
            "& .rdt-toggle": {
              display: "none",
            },
            "&:hover .rdt-toggle": {
              display: "unset",
            },
          },
          highlightOnHoverStyle: {
            backgroundColor: `${theme.palette.divider}`,
          },
          selectedHighlightStyle: {
            backgroundColor: `${theme.palette.primary.main}22 !important`,
          },
        },
        cells: {
          style: {
            padding: "8px 16px",
            fontSize: "14px",
            "& input": {
              accentColor: theme.palette.primary.main,
            },
          },
        },
        ...customStyles,
      }}
      conditionalRowStyles={[
        {
          when: (row) => row.status === false,
          style: {
            backgroundColor: theme.palette.error.main,
          },
        },
        ...(conditionalRowStyles || []),
      ]}
      {...tableProps}
    />
  );
}

export default TableClient;
